module.exports = "/assets/25b39ca48c161272f17820bf59cf3d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LY.png
// module id = 1596
// module chunks = 0